// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"443":"ad1a4570","648":"3915ebc3"}[chunkId] + ".js";
};